import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsGP: CultureInfo = {
  name: 'es-GP',
  displayName: 'español (Guadalupe)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-GP',
  parent: CultureInfoEs
};
